import * as BABYLON from 'babylonjs';

export function sphereShader(color, alpha = 1) {
	var nodeMaterial = new BABYLON.NodeMaterial('node');

	// InputBlock
	var position = new BABYLON.InputBlock('position');
	position.visibleInInspector = false;
	position.visibleOnFrame = false;
	position.target = 1;
	position.setAsAttribute('position');

	// VectorSplitterBlock
	var VectorSplitter = new BABYLON.VectorSplitterBlock('VectorSplitter');
	VectorSplitter.visibleInInspector = false;
	VectorSplitter.visibleOnFrame = false;
	VectorSplitter.target = 4;

	// MultiplyBlock
	var Multiply = new BABYLON.MultiplyBlock('Multiply');
	Multiply.visibleInInspector = false;
	Multiply.visibleOnFrame = false;
	Multiply.target = 4;

	// RemapBlock
	var Remap = new BABYLON.RemapBlock('Remap');
	Remap.visibleInInspector = false;
	Remap.visibleOnFrame = false;
	Remap.target = 4;
	Remap.sourceRange = new BABYLON.Vector2(-1, 1);
	Remap.targetRange = new BABYLON.Vector2(0.9, 1);

	// TrigonometryBlock
	var Sin = new BABYLON.TrigonometryBlock('Sin');
	Sin.visibleInInspector = false;
	Sin.visibleOnFrame = false;
	Sin.target = 4;
	Sin.operation = BABYLON.TrigonometryBlockOperations.Sin;

	// MultiplyBlock
	var Multiply1 = new BABYLON.MultiplyBlock('Multiply');
	Multiply1.visibleInInspector = false;
	Multiply1.visibleOnFrame = false;
	Multiply1.target = 4;

	// InputBlock
	var Time = new BABYLON.InputBlock('Time');
	Time.visibleInInspector = false;
	Time.visibleOnFrame = false;
	Time.target = 1;
	Time.value = 0;
	Time.min = 0;
	Time.max = 0;
	Time.isBoolean = false;
	Time.matrixMode = 0;
	Time.animationType = BABYLON.AnimatedInputBlockTypes.Time;
	Time.isConstant = false;

	// InputBlock
	var TimeMultiplier = new BABYLON.InputBlock('Time Multiplier');
	TimeMultiplier.visibleInInspector = false;
	TimeMultiplier.visibleOnFrame = false;
	TimeMultiplier.target = 1;
	TimeMultiplier.value = 2;
	TimeMultiplier.min = 0;
	TimeMultiplier.max = 0;
	TimeMultiplier.isBoolean = false;
	TimeMultiplier.matrixMode = 0;
	TimeMultiplier.animationType = BABYLON.AnimatedInputBlockTypes.None;
	TimeMultiplier.isConstant = false;

	// MultiplyBlock
	var Multiply2 = new BABYLON.MultiplyBlock('Multiply');
	Multiply2.visibleInInspector = false;
	Multiply2.visibleOnFrame = false;
	Multiply2.target = 4;

	// FresnelBlock
	var Fresnel = new BABYLON.FresnelBlock('Fresnel');
	Fresnel.visibleInInspector = false;
	Fresnel.visibleOnFrame = false;
	Fresnel.target = 4;

	// TransformBlock
	var Worldnormal = new BABYLON.TransformBlock('World normal');
	Worldnormal.visibleInInspector = false;
	Worldnormal.visibleOnFrame = false;
	Worldnormal.target = 1;
	Worldnormal.complementZ = 0;
	Worldnormal.complementW = 0;

	// InputBlock
	var World = new BABYLON.InputBlock('World');
	World.visibleInInspector = false;
	World.visibleOnFrame = false;
	World.target = 1;
	World.setAsSystemValue(BABYLON.NodeMaterialSystemValues.World);

	// TransformBlock
	var WorldPos = new BABYLON.TransformBlock('WorldPos');
	WorldPos.visibleInInspector = false;
	WorldPos.visibleOnFrame = false;
	WorldPos.target = 1;
	WorldPos.complementZ = 0;
	WorldPos.complementW = 1;

	// VectorMergerBlock
	var VectorMerger = new BABYLON.VectorMergerBlock('VectorMerger');
	VectorMerger.visibleInInspector = false;
	VectorMerger.visibleOnFrame = false;
	VectorMerger.target = 4;
	VectorMerger.xSwizzle = 'x';
	VectorMerger.ySwizzle = 'y';
	VectorMerger.zSwizzle = 'z';
	VectorMerger.wSwizzle = 'w';

	// MultiplyBlock
	var Multiply3 = new BABYLON.MultiplyBlock('Multiply');
	Multiply3.visibleInInspector = false;
	Multiply3.visibleOnFrame = false;
	Multiply3.target = 4;

	// MultiplyBlock
	var Multiply4 = new BABYLON.MultiplyBlock('Multiply');
	Multiply4.visibleInInspector = false;
	Multiply4.visibleOnFrame = false;
	Multiply4.target = 4;

	// TransformBlock
	var WorldPosViewProjectionTransform = new BABYLON.TransformBlock('WorldPos * ViewProjectionTransform');
	WorldPosViewProjectionTransform.visibleInInspector = false;
	WorldPosViewProjectionTransform.visibleOnFrame = false;
	WorldPosViewProjectionTransform.target = 1;
	WorldPosViewProjectionTransform.complementZ = 0;
	WorldPosViewProjectionTransform.complementW = 1;

	// InputBlock
	var ViewProjection = new BABYLON.InputBlock('ViewProjection');
	ViewProjection.visibleInInspector = false;
	ViewProjection.visibleOnFrame = false;
	ViewProjection.target = 1;
	ViewProjection.setAsSystemValue(BABYLON.NodeMaterialSystemValues.ViewProjection);

	// VertexOutputBlock
	var VertexOutput = new BABYLON.VertexOutputBlock('VertexOutput');
	VertexOutput.visibleInInspector = false;
	VertexOutput.visibleOnFrame = false;
	VertexOutput.target = 1;

	// PBRMetallicRoughnessBlock
	var PBRMetallicRoughness = new BABYLON.PBRMetallicRoughnessBlock('PBRMetallicRoughness');
	PBRMetallicRoughness.visibleInInspector = false;
	PBRMetallicRoughness.visibleOnFrame = false;
	PBRMetallicRoughness.target = 3;
	PBRMetallicRoughness.lightFalloff = 0;
	PBRMetallicRoughness.useAlphaTest = false;
	PBRMetallicRoughness.alphaTestCutoff = 0.35;
	PBRMetallicRoughness.useAlphaBlending = false;
	PBRMetallicRoughness.useRadianceOverAlpha = false;
	PBRMetallicRoughness.useSpecularOverAlpha = true;
	PBRMetallicRoughness.enableSpecularAntiAliasing = false;
	PBRMetallicRoughness.realTimeFiltering = false;
	PBRMetallicRoughness.realTimeFilteringQuality = 8;
	PBRMetallicRoughness.useEnergyConservation = true;
	PBRMetallicRoughness.useRadianceOcclusion = true;
	PBRMetallicRoughness.useHorizonOcclusion = true;
	PBRMetallicRoughness.unlit = false;
	PBRMetallicRoughness.forceNormalForward = false;
	PBRMetallicRoughness.debugMode = 0;
	PBRMetallicRoughness.debugLimit = 0;
	PBRMetallicRoughness.debugFactor = 1.05;

	// InputBlock
	var view = new BABYLON.InputBlock('view');
	view.visibleInInspector = false;
	view.visibleOnFrame = false;
	view.target = 1;
	view.setAsSystemValue(BABYLON.NodeMaterialSystemValues.View);

	// InputBlock
	var cameraPosition = new BABYLON.InputBlock('cameraPosition');
	cameraPosition.visibleInInspector = false;
	cameraPosition.visibleOnFrame = false;
	cameraPosition.target = 1;
	cameraPosition.setAsSystemValue(BABYLON.NodeMaterialSystemValues.CameraPosition);

	// ViewDirectionBlock
	var Viewdirection = new BABYLON.ViewDirectionBlock('View direction');
	Viewdirection.visibleInInspector = false;
	Viewdirection.visibleOnFrame = false;
	Viewdirection.target = 4;

	// DotBlock
	var Dot = new BABYLON.DotBlock('Dot');
	Dot.visibleInInspector = false;
	Dot.visibleOnFrame = false;
	Dot.target = 4;

	// NormalizeBlock
	var Normalize = new BABYLON.NormalizeBlock('Normalize');
	Normalize.visibleInInspector = false;
	Normalize.visibleOnFrame = false;
	Normalize.target = 4;

	// ClampBlock
	var Clamp = new BABYLON.ClampBlock('Clamp');
	Clamp.visibleInInspector = false;
	Clamp.visibleOnFrame = false;
	Clamp.target = 4;
	Clamp.minimum = 0;
	Clamp.maximum = 1;

	// ScaleBlock
	var Scale = new BABYLON.ScaleBlock('Scale');
	Scale.visibleInInspector = false;
	Scale.visibleOnFrame = false;
	Scale.target = 4;

	// InputBlock
	var BaseColor = new BABYLON.InputBlock('BaseColor');
	BaseColor.visibleInInspector = false;
	BaseColor.visibleOnFrame = false;
	BaseColor.target = 1;
	BaseColor.value = new BABYLON.Color3(color.r, color.g, color.b);
	BaseColor.isConstant = false;

	// MultiplyBlock
	var Multiply5 = new BABYLON.MultiplyBlock('Multiply');
	Multiply5.visibleInInspector = false;
	Multiply5.visibleOnFrame = false;
	Multiply5.target = 4;

	// MultiplyBlock
	var Multiply6 = new BABYLON.MultiplyBlock('Multiply');
	Multiply6.visibleInInspector = false;
	Multiply6.visibleOnFrame = false;
	Multiply6.target = 4;

	// ScaleBlock
	var Scale1 = new BABYLON.ScaleBlock('Scale');
	Scale1.visibleInInspector = false;
	Scale1.visibleOnFrame = false;
	Scale1.target = 4;

	// InputBlock
	var BaseColorIntensity = new BABYLON.InputBlock('BaseColor Intensity');
	BaseColorIntensity.visibleInInspector = false;
	BaseColorIntensity.visibleOnFrame = false;
	BaseColorIntensity.target = 1;
	BaseColorIntensity.value = 5;
	BaseColorIntensity.min = 0;
	BaseColorIntensity.max = 0;
	BaseColorIntensity.isBoolean = false;
	BaseColorIntensity.matrixMode = 0;
	BaseColorIntensity.animationType = BABYLON.AnimatedInputBlockTypes.None;
	BaseColorIntensity.isConstant = false;

	// ScaleBlock
	var Scale2 = new BABYLON.ScaleBlock('Scale');
	Scale2.visibleInInspector = false;
	Scale2.visibleOnFrame = false;
	Scale2.target = 4;

	// AddBlock
	var Add = new BABYLON.AddBlock('Add');
	Add.visibleInInspector = false;
	Add.visibleOnFrame = false;
	Add.target = 4;

	// LerpBlock
	var Lerp = new BABYLON.LerpBlock('Lerp');
	Lerp.visibleInInspector = false;
	Lerp.visibleOnFrame = false;
	Lerp.target = 4;

	// InputBlock
	var MinFresnel = new BABYLON.InputBlock('Min Fresnel');
	MinFresnel.visibleInInspector = false;
	MinFresnel.visibleOnFrame = false;
	MinFresnel.target = 1;
	MinFresnel.value = 0.5;
	MinFresnel.min = 0;
	MinFresnel.max = 0;
	MinFresnel.isBoolean = false;
	MinFresnel.matrixMode = 0;
	MinFresnel.animationType = BABYLON.AnimatedInputBlockTypes.None;
	MinFresnel.isConstant = false;

	// InputBlock
	var MaxFresnel = new BABYLON.InputBlock('Max Fresnel');
	MaxFresnel.visibleInInspector = false;
	MaxFresnel.visibleOnFrame = false;
	MaxFresnel.target = 1;
	MaxFresnel.value = 2.5;
	MaxFresnel.min = 0;
	MaxFresnel.max = 0;
	MaxFresnel.isBoolean = false;
	MaxFresnel.matrixMode = 0;
	MaxFresnel.animationType = BABYLON.AnimatedInputBlockTypes.None;
	MaxFresnel.isConstant = false;

	// SheenBlock
	var Sheen = new BABYLON.SheenBlock('Sheen');
	Sheen.visibleInInspector = false;
	Sheen.visibleOnFrame = false;
	Sheen.target = 2;
	Sheen.albedoScaling = false;
	Sheen.linkSheenWithAlbedo = false;

	// InputBlock
	var Sheenintensity = new BABYLON.InputBlock('Sheen intensity');
	Sheenintensity.visibleInInspector = false;
	Sheenintensity.visibleOnFrame = false;
	Sheenintensity.target = 1;
	Sheenintensity.value = 8;
	Sheenintensity.min = 0;
	Sheenintensity.max = 0;
	Sheenintensity.isBoolean = false;
	Sheenintensity.matrixMode = 0;
	Sheenintensity.animationType = BABYLON.AnimatedInputBlockTypes.None;
	Sheenintensity.isConstant = false;

	// InputBlock
	var Roughness = new BABYLON.InputBlock('Roughness');
	Roughness.visibleInInspector = false;
	Roughness.visibleOnFrame = false;
	Roughness.target = 1;
	Roughness.value = 0.7;
	Roughness.min = 0;
	Roughness.max = 0;
	Roughness.isBoolean = false;
	Roughness.matrixMode = 0;
	Roughness.animationType = BABYLON.AnimatedInputBlockTypes.None;
	Roughness.isConstant = false;

	// InputBlock
	var Metallic = new BABYLON.InputBlock('Metallic');
	Metallic.visibleInInspector = false;
	Metallic.visibleOnFrame = false;
	Metallic.target = 1;
	Metallic.value = 0.8;
	Metallic.min = 0;
	Metallic.max = 0;
	Metallic.isBoolean = false;
	Metallic.matrixMode = 0;
	Metallic.animationType = BABYLON.AnimatedInputBlockTypes.None;
	Metallic.isConstant = false;

	// InputBlock
	var Opacity = new BABYLON.InputBlock('Opacity');
	Opacity.visibleInInspector = false;
	Opacity.visibleOnFrame = false;
	Opacity.target = 1;
	Opacity.value = alpha;
	Opacity.min = 0;
	Opacity.max = 0;
	Opacity.isBoolean = false;
	Opacity.matrixMode = 0;
	Opacity.animationType = BABYLON.AnimatedInputBlockTypes.None;
	Opacity.isConstant = false;

	// SubSurfaceBlock
	var SubSurface = new BABYLON.SubSurfaceBlock('SubSurface');
	SubSurface.visibleInInspector = false;
	SubSurface.visibleOnFrame = false;
	SubSurface.target = 2;

	// InputBlock
	var SubSurfacethickness = new BABYLON.InputBlock('SubSurface thickness');
	SubSurfacethickness.visibleInInspector = false;
	SubSurfacethickness.visibleOnFrame = false;
	SubSurfacethickness.target = 2;
	SubSurfacethickness.value = 0;
	SubSurfacethickness.min = 0;
	SubSurfacethickness.max = 0;
	SubSurfacethickness.isBoolean = false;
	SubSurfacethickness.matrixMode = 0;
	SubSurfacethickness.animationType = BABYLON.AnimatedInputBlockTypes.None;
	SubSurfacethickness.isConstant = false;

	// InputBlock
	var SubSurfaceColor = new BABYLON.InputBlock('SubSurface Color');
	SubSurfaceColor.visibleInInspector = false;
	SubSurfaceColor.visibleOnFrame = false;
	SubSurfaceColor.target = 1;
	SubSurfaceColor.value = new BABYLON.Color3(0.9921568627450981, 0.9921568627450981, 0.9921568627450981);
	SubSurfaceColor.isConstant = false;

	// FragmentOutputBlock
	var FragmentOutput = new BABYLON.FragmentOutputBlock('FragmentOutput');
	FragmentOutput.visibleInInspector = false;
	FragmentOutput.visibleOnFrame = false;
	FragmentOutput.target = 2;
	FragmentOutput.convertToGammaSpace = false;
	FragmentOutput.convertToLinearSpace = false;
	FragmentOutput.useLogarithmicDepth = false;

	// InputBlock
	var BiasPower = new BABYLON.InputBlock('Bias Power');
	BiasPower.visibleInInspector = false;
	BiasPower.visibleOnFrame = false;
	BiasPower.target = 1;
	BiasPower.value = 1;
	BiasPower.min = 0;
	BiasPower.max = 0;
	BiasPower.isBoolean = false;
	BiasPower.matrixMode = 0;
	BiasPower.animationType = BABYLON.AnimatedInputBlockTypes.None;
	BiasPower.isConstant = false;

	// MultiplyBlock
	var Multiply7 = new BABYLON.MultiplyBlock('Multiply');
	Multiply7.visibleInInspector = false;
	Multiply7.visibleOnFrame = false;
	Multiply7.target = 4;

	// InputBlock
	var FresnelPower = new BABYLON.InputBlock('Fresnel Power');
	FresnelPower.visibleInInspector = false;
	FresnelPower.visibleOnFrame = false;
	FresnelPower.target = 1;
	FresnelPower.value = 1;
	FresnelPower.min = 0;
	FresnelPower.max = 0;
	FresnelPower.isBoolean = false;
	FresnelPower.matrixMode = 0;
	FresnelPower.animationType = BABYLON.AnimatedInputBlockTypes.None;
	FresnelPower.isConstant = false;

	// Connections
	position.output.connectTo(VectorSplitter.xyzIn);
	VectorSplitter.x.connectTo(Multiply.left);
	Time.output.connectTo(Multiply1.left);
	TimeMultiplier.output.connectTo(Multiply1.right);
	Multiply1.output.connectTo(Sin.input);
	Sin.output.connectTo(Remap.input);
	Remap.output.connectTo(Multiply.right);
	Multiply.output.connectTo(VectorMerger.x);
	VectorSplitter.y.connectTo(Multiply3.left);
	Remap.output.connectTo(Multiply3.right);
	Multiply3.output.connectTo(VectorMerger.y);
	VectorSplitter.z.connectTo(Multiply4.left);
	Remap.output.connectTo(Multiply4.right);
	Multiply4.output.connectTo(VectorMerger.z);
	VectorMerger.xyz.connectTo(WorldPos.vector);
	World.output.connectTo(WorldPos.transform);
	WorldPos.output.connectTo(WorldPosViewProjectionTransform.vector);
	ViewProjection.output.connectTo(WorldPosViewProjectionTransform.transform);
	WorldPosViewProjectionTransform.output.connectTo(VertexOutput.vector);
	WorldPos.output.connectTo(PBRMetallicRoughness.worldPosition);
	position.output.connectTo(Worldnormal.vector);
	World.output.connectTo(Worldnormal.transform);
	Worldnormal.output.connectTo(PBRMetallicRoughness.worldNormal);
	view.output.connectTo(PBRMetallicRoughness.view);
	cameraPosition.output.connectTo(PBRMetallicRoughness.cameraPosition);
	BaseColor.output.connectTo(Multiply5.left);
	BaseColor.output.connectTo(Scale.input);
	WorldPos.output.connectTo(Viewdirection.worldPosition);
	cameraPosition.output.connectTo(Viewdirection.cameraPosition);
	Viewdirection.output.connectTo(Dot.left);
	Worldnormal.xyz.connectTo(Normalize.input);
	Normalize.output.connectTo(Dot.right);
	Dot.output.connectTo(Clamp.value);
	Clamp.output.connectTo(Scale.factor);
	Scale.output.connectTo(Scale1.input);
	BaseColorIntensity.output.connectTo(Scale1.factor);
	Scale1.output.connectTo(Multiply6.left);
	Scale.output.connectTo(Scale2.input);
	Worldnormal.output.connectTo(Fresnel.worldNormal);
	Viewdirection.output.connectTo(Fresnel.viewDirection);
	BiasPower.output.connectTo(Fresnel.bias);
	FresnelPower.output.connectTo(Multiply7.left);
	Sin.output.connectTo(Multiply7.right);
	Multiply7.output.connectTo(Fresnel.power);
	Fresnel.fresnel.connectTo(Multiply2.left);
	Sin.output.connectTo(Multiply2.right);
	Multiply2.output.connectTo(Add.left);
	MinFresnel.output.connectTo(Lerp.left);
	MaxFresnel.output.connectTo(Lerp.right);
	Fresnel.fresnel.connectTo(Lerp.gradient);
	Lerp.output.connectTo(Add.right);
	Add.output.connectTo(Scale2.factor);
	Scale2.output.connectTo(Multiply6.right);
	Multiply6.output.connectTo(Multiply5.right);
	Multiply5.output.connectTo(PBRMetallicRoughness.baseColor);
	Metallic.output.connectTo(PBRMetallicRoughness.metallic);
	Roughness.output.connectTo(PBRMetallicRoughness.roughness);
	Opacity.output.connectTo(PBRMetallicRoughness.opacity);
	Sheenintensity.output.connectTo(Sheen.intensity);
	BaseColor.output.connectTo(Sheen.color);
	Roughness.output.connectTo(Sheen.roughness);
	Sheen.sheen.connectTo(PBRMetallicRoughness.sheen);
	SubSurfacethickness.output.connectTo(SubSurface.thickness);
	SubSurfaceColor.output.connectTo(SubSurface.tintColor);
	SubSurface.subsurface.connectTo(PBRMetallicRoughness.subsurface);
	PBRMetallicRoughness.lighting.connectTo(FragmentOutput.rgb);
	PBRMetallicRoughness.alpha.connectTo(FragmentOutput.a);

	// Output nodes
	nodeMaterial.addOutputNode(VertexOutput);
	nodeMaterial.addOutputNode(FragmentOutput);
	nodeMaterial.build();

	return nodeMaterial;
}
